import React, { ComponentClass } from 'react';
import Billboard, { BillboardProps } from 'components/ribbons/billboard';
import errorBoundary from 'presentation/hocs/errorBoundary';
import DomainSearchForm from 'components/ribbons/domain-search-start/DomainSearchForm';
import visibilitySet from 'presentation/hocs/visibilitySet';

import { DomainSearchFormProps } from '../domain-search-start';

export interface OuterProps extends DomainSearchFormProps, BillboardProps {}

const PureBillboardDomain = ({ colorway, search, ...billboardProps }: OuterProps) => {
  return (
    <Billboard
      colorway={colorway}
      {...billboardProps}
      additionalText={<DomainSearchForm search={search} ribbonName={'billboardDomain'} id={billboardProps.id} />}
    />
  );
};

PureBillboardDomain.displayName = 'BillboardDomain';

export default errorBoundary(visibilitySet(PureBillboardDomain)) as ComponentClass<OuterProps>;
